<template>
    <svg v-if="type === 'image'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none" :class="iconClass">
        <path
            d="M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934V13H20V5H4V18.999L14 9L17 12V14.829L14 11.8284L6.827 19H14V21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
            :fill="fillColor" />
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        :class="iconClass">
        <path
            d="M14.3516 3.89062C15.3663 3.89066 16.3391 4.29416 17.0566 5.01172C17.7099 5.66498 18.1009 6.52982 18.166 7.44531L19.5176 6.06445C19.7848 5.79564 20.1256 5.61163 20.4971 5.53613C20.8684 5.46072 21.2537 5.49663 21.6045 5.63965C21.9555 5.78284 22.257 6.02699 22.4697 6.34082C22.6823 6.65458 22.7968 7.02433 22.7998 7.40332V16.3496C22.8009 16.7298 22.6883 17.1018 22.4756 17.417C22.2627 17.7322 21.9596 17.9761 21.6064 18.1172C21.3789 18.2138 21.1339 18.2633 20.8867 18.2627C20.6318 18.2627 20.3796 18.2118 20.1445 18.1133C19.9094 18.0147 19.6964 17.8703 19.5176 17.6885L18.168 16.3057C18.1065 17.2274 17.7139 18.0995 17.0566 18.7568C16.3391 19.4742 15.3662 19.8769 14.3516 19.877H4.77051C3.75575 19.877 2.78203 19.4743 2.06445 18.7568C1.34686 18.0392 0.943359 17.0656 0.943359 16.0508V7.7168C0.943404 6.7021 1.347 5.72926 2.06445 5.01172C2.78205 4.29412 3.75567 3.89063 4.77051 3.89062H14.3516ZM4.77051 5.4209C4.16161 5.4209 3.57704 5.66319 3.14648 6.09375C2.71607 6.52425 2.47465 7.10804 2.47461 7.7168V16.0508C2.47461 16.6597 2.71593 17.2442 3.14648 17.6748C3.57703 18.1053 4.16168 18.3467 4.77051 18.3467H14.3516C14.9602 18.3466 15.5441 18.1051 15.9746 17.6748C16.4052 17.2442 16.6475 16.6597 16.6475 16.0508V9.44434C16.6416 9.4074 16.6361 9.36988 16.6357 9.33203C16.6353 9.28518 16.6396 9.23888 16.6475 9.19336V7.7168C16.6474 7.10796 16.4051 6.52427 15.9746 6.09375C15.5441 5.66323 14.9604 5.42094 14.3516 5.4209H4.77051ZM20.8086 7.0293C20.7337 7.04436 20.6649 7.08135 20.6113 7.13574L18.1777 9.625V14.123L20.6113 16.5869C20.6644 16.6423 20.7333 16.6803 20.8086 16.6953C20.8838 16.7104 20.9619 16.7016 21.0322 16.6709C21.1027 16.6431 21.1637 16.595 21.2061 16.5322C21.2483 16.4695 21.2701 16.395 21.2695 16.3193V7.40332C21.2702 7.32762 21.2483 7.25322 21.2061 7.19043C21.1637 7.12759 21.1027 7.07959 21.0322 7.05176C20.9617 7.0221 20.8836 7.01429 20.8086 7.0293ZM8.6543 15.0566C8.85719 15.0567 9.05182 15.1368 9.19531 15.2803C9.33876 15.4237 9.41984 15.6184 9.41992 15.8213C9.41992 16.0242 9.33872 16.2188 9.19531 16.3623C9.0518 16.5058 8.85725 16.5869 8.6543 16.5869H4.82812C4.62516 16.5869 4.43063 16.5058 4.28711 16.3623C4.14359 16.2188 4.0625 16.0243 4.0625 15.8213C4.06258 15.6184 4.14366 15.4237 4.28711 15.2803C4.4306 15.1369 4.6253 15.0566 4.82812 15.0566H8.6543Z"
            :fill="fillColor" />
    </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
    /** 图标大小类名，默认为 w-6 h-6 */
    size?: string
    /** 图标颜色，默认为 currentColor */
    color?: string
    /** 是否启用hover效果 */
    hoverable?: boolean
    /** 额外的CSS类名 */
    class?: string
    type?: 'video' | 'image'
}

const props = withDefaults(defineProps<Props>(), {
    size: 'w-6 h-6',
    color: 'currentColor',
    hoverable: false,
    class: '',
    type: 'image',
})

const iconClass = computed(() => {
    const baseClasses = props.size
    const hoverClasses = props.hoverable
        ? 'group-hover:text-white transition-colors duration-200'
        : ''
    const customClasses = props.class

    return [baseClasses, hoverClasses, customClasses].filter(Boolean).join(' ')
})

const fillColor = computed(() => {
    // 如果设置了hoverable，使用currentColor以支持CSS颜色变化
    if (props.hoverable) {
        return 'currentColor'
    }
    return props.color
})
</script>
